<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
             <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" flat text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white" flat text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12>
                <div>
                    <v-layout row wrap fill-height class="pa-2 header">
                        
                        <v-flex xs12 sm3 md2>
                            <div class="title text-color">Offices</div>
                        </v-flex>
                       
                        <v-flex  xs12 sm9 md10 class="filter_form">
                              <v-form 
                                @submit.prevent="validateBeforeSubmit('filterList')" 
                                data-vv-scope="filterList" 
                                id="filterList" 
                                ref="form">
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field name="Name" 
                                        label="Search By Name" 
                                        id="name" 
                                        regular
                                        single-line 
                                        v-model="filters.name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md2>
                                        <v-text-field 
                                        name="Unit Number" 
                                        label="Unit Number" 
                                        id="unit_no" 
                                        regular
                                        single-line 
                                        v-model="filters.unit_no">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md3 class='buttoncenter pl-5'>
                                        <v-btn small color="primary" type="submit">Apply</v-btn>
                                        <v-btn small color="primary" class="btn_reset ml-1" @click="resetFilter">Reset</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4>
                                         <v-btn color="primary" class="float_right ml-3" to="/addOffice" small>Create Office</v-btn>
                                         <v-btn small color="primary" class="float_right" @click="upload_office_dialog_box=true">Upload Offices</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                            
                        </v-flex>
                            
                    </v-layout>
                </div>

                <div>
                    <v-layout row wrap>
                        <v-flex sm12 md12>
                            <v-data-table 
                            :headers="headers" 
                            :items="offices" 
                             item-key="id" 
                            class="elevation-1" 
                            :loading="is_loading" 
                            :options.sync="options" 
                            :footer-props="{'items-per-page-options': [15,20,40,80]}" 
                            :server-items-length="total_items" 
                            :items-per-page="15"
                            >
                                <template  v-slot:body="{ items }" v-if="!is_loading && total_items!='0'">
                                    <tbody>
                    
                                        <tr v-for="item in items" :key="item.id">
                                            
                                            <td v-if="item.name">
                                                <router-link :to="{ name:'showOfficeDetails',params: { id:item.id } }">
                                                    {{ item.name |capitalize}}</router-link>
                                            </td><td v-else> - </td>

                                            <td v-if="item.address">{{ item.address |capitalize}}</td><td v-else> - </td>
                                            <td v-if="item.wing">{{ item.wing.name }}</td><td v-else> - </td>
                                             <td v-if="item.unit_no">{{ item.unit_no }}</td><td v-else> - </td>
                                            <td v-if="item.email">{{ item.email }}</td><td v-else> - </td>
                                            <td>
                                                <v-btn text icon color="primary" :to="`offices/edit/${item.id}`">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                                
                        <template v-slot:loading> Loading... Please wait </template>
                        <template v-slot:no-results> No data available </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </div>

            </v-flex>
        </v-layout>

        <!-- filter model -->
        <v-dialog v-model="filter_dialog_box" persistent :overlay="false" max-width="500px" transition="dialog-transition">
            <v-card class='pa-5'>
                <v-form @submit.prevent="validateBeforeSubmit('filterList')" data-vv-scope="filterList" id="filterList" ref="form">
                    <v-card-text>
                        <v-card-title primary-title>
                            <span class="headline">Filters</span>
                        </v-card-title>
                        <v-container fluid grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-text-field name="Name" label="Name" id="name" v-model="filters.name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-autocomplete :items="wings_list" name="Wing" v-model="filters.wing_id" label="Wing" item-text="name" return-object item-value="id" clearable>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>

                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="primary" type="submit">Apply</v-btn>
                        <v-btn text small color="error" @click="resetFilter">Reset</v-btn>
                        <v-btn text small @click=" filter_dialog_box =  false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
       <!-- Upload Office model -->
    <v-dialog v-model="upload_office_dialog_box" scrollable :overlay="false" max-width="600px" min-height="800px" transition="dialog-transition">
        <v-card class="pa-5">
            <v-form>
                  <v-card-title>
                    <p class="text-color pb-0">Upload File</p>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                            v-model="files"
                            label="File input"
                            placeholder="Select your files"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                            :show-size="1000"
                        ></v-file-input>
                </v-card-text>
               <v-card-text>
                    <a v-bind:href="`${publicPath}/files/Office_Sample_Template.xlsx`" download><u><b>Download Sample File</b></u></a>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="uploadfile">Upload</v-btn>
                    <v-btn color="black" text small @click="upload_office_dialog_box=false">Cancel</v-btn>
                </v-card-actions>      
            </v-form>
        </v-card>
    </v-dialog>

        <!-- Delete Office model -->
        <v-dialog v-model="delete_office_dialog_box" scrollable :overlay="false" max-width="600px" transition="dialog-transition">
            <v-card>
                <v-form>
                    <v-card-text>
                        <v-card-title primary-title>
                            <span class="headline">Are you sure you want to delete this Office ?</span>
                        </v-card-title>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small @click="confirmDeleteOffice">Delete</v-btn>
                        <v-btn color="black" text small @click="delete_office_dialog_box=false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {

    watch: {
        options: {
            handler() {
                this.getList();
            }
        }
    },
    methods: {
        getList: function () {
            this.error = '',
            this.success_message='',
            this.is_loading = true;
            this.options.filters = Object.assign({}, this.filters);
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices`, {params: this.options})
            .then((response) => {
                if (response.data.status == 1) {
                    this.offices = response.data.office_list.data;
                    this.total_items = response.data.office_list.total; 
                    this.is_loading = false;
                }
                if (response.data.status == 0) {
                    this.error = response.message;
                    this.is_loading = false;
                }

            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });

        },

        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        filterList() {
            let filter_values = Object.values(this.filters);
            if (filter_values.join('').length > 0) {
                this.$router.replace({
                    name: "offices",
                    query: {
                        filters: true,
                        name: this.filters.name,
                        unit_no: this.filters.unit_no,
                    }
                });
                this.displayFilterChips(this.filters);
                this.is_filtered = true;
            } else {
                this.$router.replace({
                    name: "offices"
                });
            }
            this.getList();
            this.filter_dialog_box = false;
        },
        clearFilter: function (filter, key) {
            this.filter_chips[key] = this.filters[key] = '';
            this.filterList();
        },
        resetFilter() {
            this.$router.replace({
                name: 'offices',
                query: {}
            });
            this.getList();
            this.resetFiltersParameters();
            this.is_filtered = false;
            this.filter_dialog_box = false;
        },
        resetFiltersParameters: function () {
            for (var key in this.filters) {
                this.filters[key] = '';
                this.filter_chips[key] = '';
            }
        },
        applyFiltersOnLoad: function () {
            this.filters.name = this.$route.query.name;
            this.filters.unit_no = this.$route.query.unit_no;
            this.displayFilterChips(this.filters);
        },
        displayFilterChips: function (filters) {
            if (this.$route.query.filters) {
                this.filter_chips.name = filters.name;
                this.filter_chips.unit_no = filters.unit_no;
                this.is_filtered = true;
            }
        },
        deleteOffice: function (office) {
            this.delete_office_dialog_box = true;
            this.to_be_deleted_office = office;

        },
        confirmDeleteOffice: function () {

            axios
                .post(`${process.env.VUE_APP_API_URL}/api/offices/` + this.to_be_deleted_office.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.delete_office_dialog_box = false;
                        this.getList();
                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
         uploadfile: function () 
         {
            let formData = new FormData();
            formData.append('file', this.files);
            axios.post(`${process.env.VUE_APP_API_URL}/api/offices/uploadoffice`,formData, 
            { headers: {'Content-Type': 'multipart/form-data'} })
            .then((response) => {
                    this.upload_office_dialog_box = false;
                   
                   if (response.data.status == 1) {
                    // this.$router.push({ name: 'offices',  params:{message:'Offices Uploaded Successfully'}});
                    this.loading = false;
                    this.alert=true;
                    this.message = response.data.message;
                    window.location.reload();
                    }
                    if (response.data.status == 0) {
                        this.alert_error=true;
                        this.error = response.data.message
                    }
                })
                .catch(function () {

                });

        },
    },
    data() {
        return {
            options: {},
            role: '',
            upload_office_dialog_box:false,
            files:null,
            error:'',
            success:'',
            total_items: 10,
            headers: [
              
                {
                    text: 'Name',
                    align: 'left',
                    value: 'name',
                    width: "30%",
                    sortable:false
                },
                {
                    text: 'Address',
                    align: 'left',
                    value: 'address',
                    width: "30%",
                    sortable:false
                },
                {
                    text: 'Wing',
                    value: 'wing.name',
                    sortable:false
                },
                  {
                    text: 'Unit No',
                    align: 'left',
                    value: 'unit_no',
                    sortable:false
                },
                  {
                    text: 'Email',
                    align: 'left',
                    value: 'email',
                    sortable:false
                },
                {
                    text: 'Action',
                    value: '',
                    sortable:false
                },
                
            ],
            offices: [],
            filters: {
                name: '',
                unit_no: '',
            },
            filter_chips: {
                name: '',
                unit_no: '',
            },
            users: [],
            success_message:'',
            filter_dialog_box: false,
            is_filtered: false,
            is_loading: false,
            wings_list: [],
            delete_office_dialog_box: false,
            to_be_deleted_office: {},
            message:'',
            alert: false,
            alert_error:false,
            publicPath: process.env.VUE_APP_URL
        }
    },
    mounted() {
      if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.role = localStorage.getItem('visitor_management_role');
        this.applyFiltersOnLoad();

    }
};
</script>
